import axios from "axios";
import queryString from "query-string";
import { store } from "../redux/store";
import { setUnauthorized } from "../redux/slices/userSlice";

const getCookie = (name: string): string | null => {
    if (typeof document === "undefined") return null;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const rawValue = parts.pop()?.split(";").shift();
        return rawValue ? decodeURIComponent(rawValue) : null;
    }
    return null;
};

//const getBaseDomain = () => {
//    const hostnameParts = window.location.hostname.split('.');
//    // Handle different domain depths (e.g., cards.live-let.com → live-let.com)
//    const baseDomain = hostnameParts.slice(-2).join('.'); // ['live-let', 'com']  
//    return `https://${baseDomain}:8008`;
//};

// axios を通さない送信（一括取り込みの進み具合つきアップロードなど）でも同じ認証を付けるための見出し。
// 9/9 から名刺API は全リクエストで Bearer を必須にしたが、一括取り込みだけ付いておらず 401 になっていた（2026-11-02）
export const getCardsAuthHeaders = (): Record<string, string> => {
    const token = getCookie("cards_token");
    const userIdRaw = getCookie("cards_user_id");
    if (!token || !userIdRaw) return {};
    return { Authorization: `Bearer ${token}`, "X-Cards-User-Id": userIdRaw };
};

const apiURL = import.meta.env.VITE_API_URL + "/capi";

// config axios
const axiosClient = axios.create({
    baseURL: apiURL,
    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },

    paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use(
    (config) => {
        const token = getCookie("cards_token");
        const userIdRaw = getCookie("cards_user_id");

        if (!token || !userIdRaw) {
            return Promise.reject(new Error("Unauthorized: Missing security cookies"));
        }

        // Set bearer token standard authorization header and user id header
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["X-Cards-User-Id"] = userIdRaw;

        const state = store.getState();
        const user = state.user.data;
        const companyKey = user?.companyKey || 2;
        const companyApiKey = "09df728269";
        const userId = Number(userIdRaw);
        const legacyUserToken = user?.userToken || "7e16b5527c77ea58";

        if (!config.data) {
            config.data = { externalUserKey: userId, userToken: legacyUserToken, companyKey, companyApiKey };
        } else if (config.data instanceof FormData) {
            config.data.set("externalUserKey", userId.toString());
            config.data.set("userToken", legacyUserToken);
            config.data.set("companyKey", companyKey.toString());
            config.data.set("companyApiKey", companyApiKey);
        } else if (typeof config.data === "object") {
            config.data = { ...config.data, externalUserKey: userId, userToken: legacyUserToken, companyKey, companyApiKey };
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosClient.interceptors.response.use(
    (response) => {
        if (response && response.data) {
            return response.data;
        }
        return response;
    },
    (error: any) => {
        if (error.response && error.response.status === 401) {
            // Dispatch unauthorized state to Redux to show blocked screen
            store.dispatch(setUnauthorized(true));
        }
        return Promise.reject(error);
    }
);

export default axiosClient;
